<template>
  <div>
    <ExpressProblemHead
            :countFilterParams="countFilterParams"
            :showFilter="showFilter"
            @toggleFilter="toggleFilter"
            @selectAll="selectAll"
            @filter="$emit('filter')"
            @reload="$emit('reload')"
            @approve="$emit('approve')"
            @refund="$emit('refund')"
    />

    <div class="table-filter-wrap">
      <ExpressProblemFilter
              :showFilter="showFilter"
              :filterGetParams="filterGetParams"
              @close="closeFilter"
              @changeFilter="data => $emit('changeFilter', data)"
              @resetFilter="$emit('resetFilter')"
      />

      <ExpressProblemTable
              :selectedNow="selectedNow"
              :isModalInfoPopup="isModalInfoPopup"
              :countFilterParams="countFilterParams"
              :itemId="itemId"
              @showMore="$emit('showMore')"
              @resetFilter="$emit('resetFilter')"
              @updateTable="$emit('updateTable')"
              @reload="$emit('reload')"
              @approve="(id) => $emit('approve', id)"
              @refund="(id) => $emit('refund', id)"
              @changeInfoPopup="(val, id) => $emit('changeInfoPopup', val, id)"
              @downloadFiles="type => $emit('downloadFiles', type)"
      />
    </div>
  </div>
</template>

<script>


  import ExpressProblemHead from "./ExpressProblemHead/ExpressProblemHead";
  import ExpressProblemFilter from "./ExpressProblemFilter/ExpressProblemFilter";
  import ExpressProblemTable from "./ExpressProblemTable/ExpressProblemTable";

  export default {
    name: "ExpressProblemTableSection",

    components: {
      ExpressProblemHead,
      ExpressProblemFilter,
      ExpressProblemTable,
    },

    props: {
      countFilterParams: Number,
      filterGetParams: Object,
      isModalInfoPopup: {
        type: Boolean,
        default: false,
      },
      itemId: Number,
    },

    data(){
      return{
        showFilter: false,
        selectedNow: false,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },

      selectAll(val) {
        this.selectedNow = val
      },
    }
  }
</script>

<style scoped>

</style>
